import { render, staticRenderFns } from "./SearchNew.vue?vue&type=template&id=6b8a6d14&scoped=true"
import script from "./SearchNew.vue?vue&type=script&lang=js"
export * from "./SearchNew.vue?vue&type=script&lang=js"
import style0 from "./SearchNew.vue?vue&type=style&index=0&id=6b8a6d14&prod&scoped=true&lang=scss"
import style1 from "./SearchNew.vue?vue&type=style&index=1&id=6b8a6d14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a6d14",
  null
  
)

export default component.exports